import { useEffect, useState } from "react";
import { Ban, X, AlertTriangle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

export function LoyaltyBlocked({ contestId, cfg, up }) {
  const [list, setList] = useState([]);
  const [susp, setSusp] = useState([]);
  const [code, setCode] = useState("");
  const [reason, setReason] = useState("");
  const load = () => { api.loyaltyBlocked(contestId).then(setList).catch(() => {}); api.loyaltySuspicious(contestId).then(setSusp).catch(() => {}); };
  useEffect(() => { if (contestId) load(); }, [contestId]); // eslint-disable-line
  if (!contestId) return null;
  const block = async (c = code, r = reason) => {
    if (!c.trim()) return toast.error("Inserisci il codice carta da bloccare");
    await api.loyaltyBlock(contestId, c, r); setCode(""); setReason(""); toast.success("Carta bloccata"); load();
  };
  const open = susp.filter((s) => !s.blocked);
  return (
    <div className="rounded-lg border border-border p-2 space-y-1.5" data-testid="loyalty-blocked">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-xs font-semibold flex items-center gap-1.5 flex-1"><Ban className="h-3.5 w-3.5 text-red-500" /> Carte bloccate <span className="font-normal text-muted-foreground">— le carte in elenco non possono più giocare</span></p>
        <label className="text-xs text-muted-foreground flex items-center gap-1.5">Avviso admin dopo <Input type="number" min={1} className="h-7 w-16 text-xs" value={cfg?.alert_threshold ?? 5} onChange={(e) => up({ alert_threshold: Number(e.target.value) || 5 })} data-testid="loyalty-alert-threshold" /> rifiuti/giorno</label>
      </div>
      {open.length > 0 && (
        <div className="rounded-md bg-amber-500/10 border border-amber-500/30 p-2 space-y-1" data-testid="loyalty-suspicious">
          <p className="text-xs font-semibold text-amber-600 flex items-center gap-1"><AlertTriangle className="h-3.5 w-3.5" /> Carte con tentativi rifiutati oggi</p>
          {open.map((s) => (
            <div key={s.code} className="flex items-center gap-2 text-xs" data-testid={`loyalty-suspicious-${s.code}`}>
              <code className="font-mono-code">{s.code}</code>
              <span className="text-muted-foreground flex-1 truncate">{s.rejected_today} rifiuti · {s.reason}</span>
              <Button type="button" size="sm" variant="outline" className="h-6 px-2 text-[11px] border-border text-red-500" onClick={() => block(s.code, `${s.rejected_today} tentativi rifiutati il ${new Date().toLocaleDateString("it-IT")}`)} data-testid={`loyalty-suspicious-block-${s.code}`}>Blocca</Button>
            </div>
          ))}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="Codice carta" className="font-mono-code flex-1 min-w-[160px]" data-testid="loyalty-block-code" />
        <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivo (facoltativo)" className="flex-1 min-w-[160px]" data-testid="loyalty-block-reason" />
        <Button type="button" size="sm" variant="outline" className="h-10 border-border text-red-500" onClick={() => block()} data-testid="loyalty-block-submit">Blocca</Button>
      </div>
      {list.length > 0 && (
        <ul className="text-xs divide-y divide-border max-h-40 overflow-auto" data-testid="loyalty-blocked-list">
          {list.map((b) => (
            <li key={b.code} className="flex items-center gap-2 py-1" data-testid={`loyalty-blocked-${b.code}`}>
              <code className="font-mono-code">{b.code}</code>
              <span className="text-muted-foreground flex-1 truncate">{b.reason || "—"} · {b.plays} giocate · {new Date(b.created_at).toLocaleDateString("it-IT")}</span>
              <button type="button" onClick={async () => { await api.loyaltyUnblock(contestId, b.code); toast.success("Carta sbloccata"); load(); }} className="text-muted-foreground hover:text-foreground" title="Sblocca" data-testid={`loyalty-unblock-${b.code}`}><X className="h-3.5 w-3.5" /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
